import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, combineLatest, Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { CustomAlertService } from '../_components/custom-alert/custom-alert.service';

const API_URL = environment.apiUrl;

@Injectable({
  providedIn: 'root'
})
export class HorarioService {

  private horarioCambiosSubject = new BehaviorSubject({accion: '', obj: null});

  horarioCambios$ = this.horarioCambiosSubject.asObservable();

  constructor(private http: HttpClient, private customAlert: CustomAlertService) { }

  gurdarHorario(data: any) {
    return this.http.post<any[]>(`${API_URL}/api/horarios/importar`, data).pipe(
      catchError(err => {
        this.handleError(err);
        return of([]);
      })
    );
  }

  getHorarioDia(fecha: string): Observable<any[]> {
    return this.http.get<any[]>(`${API_URL}/api/Horarios/dia/${fecha}`).pipe(
      catchError(err => {
        this.handleError(err);
        return of([]);
      })
    );
  }

  getHorarios(): Observable<any> {
    const baseObservable$ = this.http.get<any[]>(`${API_URL}/api/Horarios`).pipe(
      catchError(err => {
        this.handleError(err);
        return of([]);
      })
    );

    return combineLatest([baseObservable$, this.horarioCambios$]).pipe(
      map(([data, cambios]) => {
        if (cambios.accion === 'delete') {
          data.splice(data.findIndex(item => item.escuelaId === cambios.obj.escuelaId && item.fechaInicio === cambios.obj.fechaInicio), 1);
        }
        return data;
      })
    );
  }

  eliminarHorario(escuelaId: number, fechaInicio: string) {
    return this.http.delete<any[]>(`${API_URL}/api/Horarios/seccion/${escuelaId}/fecha/${fechaInicio}`).pipe(
      catchError(err => {
        this.handleError(err);
        return of(false);
      })
      , tap(data => {
        if (data) {
          this.horarioCambiosSubject.next({accion: 'delete', obj: {escuelaId, fechaInicio}});
        }
      })
    );
  }

  handleError(error) {
    this.customAlert.setCustomMessage({
      tipo: 'error',
      texto: `Error en el pedido. ${error.error}.<br> Codigo de error: ${error.statusText}`
    });
  }
}
